var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaghsim2Amodi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5,3.1c-0.3,0-0.5-0.2-0.5-0.5V1h-1.6c-0.3,0-0.5-0.2-0.5-0.5S27.2,0,27.4,0H30v2.6C30,2.8,29.8,3.1,29.5,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,24c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C30,23.7,29.8,24,29.5,24z M29.5,17 c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C30,16.8,29.8,17,29.5,17z M29.5,10.1c-0.3,0-0.5-0.2-0.5-0.5 v-4c0-0.3,0.2-0.5,0.5-0.5S30,5.4,30,5.7v4C30,9.9,29.8,10.1,29.5,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,29.9h-2.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5H29v-1.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,29.9h-3.8c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h3.8c0.3,0,0.5,0.2,0.5,0.5C24.8,29.7,24.6,29.9,24.3,29.9z  M17.6,29.9h-3.8c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h3.8c0.3,0,0.5,0.2,0.5,0.5C18.1,29.7,17.9,29.9,17.6,29.9z  M10.9,29.9H7.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h3.8c0.3,0,0.5,0.2,0.5,0.5C11.4,29.7,11.2,29.9,10.9,29.9z  M4.2,29.9H4.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0.1c0.3,0,0.5,0.2,0.5,0.5C4.7,29.7,4.5,29.9,4.2,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6,29.9H0v-2.6c0-0.3,0.2-0.5,0.5-0.5S1,27.1,1,27.4V29h1.6c0.3,0,0.5,0.2,0.5,0.5C3.1,29.7,2.8,29.9,2.6,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,24.8c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5S1,20.1,1,20.3v4C1,24.6,0.8,24.8,0.5,24.8z M0.5,17.9 c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5S1,13.1,1,13.4v4C1,17.6,0.8,17.9,0.5,17.9z M0.5,10.9c-0.3,0-0.5-0.2-0.5-0.5v-4 C0,6.2,0.2,6,0.5,6S1,6.2,1,6.5v4C1,10.7,0.8,10.9,0.5,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,3.1C0.2,3.1,0,2.8,0,2.6V0h2.6c0.3,0,0.5,0.2,0.5,0.5S2.8,1,2.6,1H1v1.6C1,2.8,0.8,3.1,0.5,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9,1h-0.1c-0.3,0-0.5-0.2-0.5-0.5S25.5,0,25.7,0h0.1c0.3,0,0.5,0.2,0.5,0.5S26.1,1,25.9,1z M22.9,1h-3.8 c-0.3,0-0.5-0.2-0.5-0.5S18.8,0,19.1,0h3.8c0.3,0,0.5,0.2,0.5,0.5S23.1,1,22.9,1z M16.2,1h-3.8c-0.3,0-0.5-0.2-0.5-0.5 S12.1,0,12.4,0h3.8c0.3,0,0.5,0.2,0.5,0.5S16.5,1,16.2,1z M9.5,1H5.7C5.4,1,5.2,0.8,5.2,0.5S5.4,0,5.7,0h3.8C9.8,0,10,0.2,10,0.5 S9.8,1,9.5,1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 0.3,
    width: 1.9,
    height: 29.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 0.3,
    width: 1.9,
    height: 29.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaghsim2Amodi);
export default __webpack_public_path__ + "static/media/taghsim_2_amodi.72a2408ccc85c9e759d652326c3be992.svg";
export { ForwardRef as ReactComponent };